import { EMAIL_API } from './endpoints';
import { emailConfig } from '../config/emailConfig';
import type { EmailPayload } from '../types/email';

const createEmailPayload = (data: any): EmailPayload => ({
  data,
  smtp: {
    host: emailConfig.smtp.host,
    port: emailConfig.smtp.port,
    secure: emailConfig.smtp.secure
  },
  to: emailConfig.smtp.contactEmail
});

const sendRequest = async (endpoint: string, data: any): Promise<void> => {
  console.log('Sending email request to:', endpoint);
  console.log('Email payload:', createEmailPayload(data));

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(createEmailPayload(data))
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Failed to send email' }));
    throw new Error(error.message || 'Failed to send email');
  }

  return response.json();
};

export const emailApi = {
  sendContactForm: async (data: any) => {
    return sendRequest(EMAIL_API.CONTACT, {
      type: 'contact',
      ...data
    });
  },

  sendTrainingRequest: async (data: any) => {
    return sendRequest(EMAIL_API.TRAINING, {
      type: 'training',
      ...data
    });
  }
};